angular
  .module('app', [
    'ui.router',
    'ngAnimate',
    'ngMaterialize',
    'ngStorage'
  ]);
